import { Container } from '@almbrand/container';
import { Grid, GridCell } from '@almbrand/grid';
import { Headline } from '@almbrand/headline';
import { useModal } from 'hooks';
import { replacePlaceholdersSummaryComponent } from '../../../services/PlaceholderService';
import styles from './SummaryComponent.module.scss';

export interface SeeDetailsSection {
	linkText: string;
	title: string;
	subtitle: string;
	content: string;
	contentType: string;
	contentId: number;
}
interface SummaryComponentProps {
	title: string;
	productTitle: string;
	productIntroduction: string;
	priceAmountHeader?: string;
	regularPriceLabel: string;
	yourPriceLabel: string;
	additionalPriceDetails: string[];
	seeDetailsSection: SeeDetailsSection;
	contentType?: string;
	contentId?: number;
}

export const SummaryComponent: React.FC<SummaryComponentProps> = ({
	title,
	productTitle,
	productIntroduction,
	regularPriceLabel,
	yourPriceLabel,
	additionalPriceDetails,
	seeDetailsSection,
}) => {
	const { displayModal } = useModal();

	const regularPriceLabelArray = regularPriceLabel.split(/({{.*?}})/).map((str) => str.trim());
	const yourPriceLabelArray = yourPriceLabel.split(/({{.*?}})/).map((str) => str.trim());

	const replacedPlaceholder: SummaryProductDetailsBlock = {
		regularPriceLabel: regularPriceLabelArray[1],
		yourPriceLabel: yourPriceLabelArray[1],
		additionalPriceDetails,
	};

	replacePlaceholdersSummaryComponent(replacedPlaceholder);

	return (
		<section className={styles.SummaryComponent}>
			<Container
				noPadding
				mobileWidth='fullWidth'
			>
				<Grid>
					<GridCell nogutter>
						<Headline
							variant='h1'
							fontColor='primary'
							title={title}
							size='md'
						/>
					</GridCell>
				</Grid>
			</Container>
			<Container
				noPadding
				mobileWidth='fullWidth'
			>
				<div className={styles.SummaryComponent__card}>
					<div className={styles.SummaryComponent__card__main}>
						<div className={styles.SummaryComponent__card__main__header}>
							<Headline
								variant='h2'
								fontColor='primary'
								title={productTitle}
								size='xs'
							/>

							<p className={styles.SummaryComponent__card__main__header__subtitle}>
								{productIntroduction}
							</p>
						</div>

						<div className={styles.SummaryComponent__card__main__content}>
							<div className={styles.SummaryComponent__currency}>Kr. pr. md.</div>
							<div className={styles.SummaryComponent__card__main__content__pricing}>
								<div className={styles.SummaryComponent__card__main__content__pricing__labels}>
									<div
										className={
											styles.SummaryComponent__card__main__content__pricing__labels__normal_price
										}
									>
										<Headline
											variant='h2'
											fontColor='secondaryGrey'
											title={regularPriceLabelArray[0]}
											size='xs'
										/>
									</div>
									<div
										className={
											styles.SummaryComponent__card__main__content__pricing__labels__discount_price
										}
									>
										<Headline
											variant='h2'
											fontColor='primary'
											title='Din pris'
											size='xs'
										/>
									</div>
								</div>

								<div className={styles.SummaryComponent__card__main__content__pricing__values}>
									<div
										className={
											styles.SummaryComponent__card__main__content__pricing__values__normal_price
										}
									>
										<Headline
											variant='h2'
											fontColor='secondaryGrey'
											title={replacedPlaceholder.regularPriceLabel} //1.844,-
											size='xs'
										/>
									</div>
									<div
										className={
											styles.SummaryComponent__card__main__content__pricing__values__discount_price
										}
									>
										<Headline
											variant='h2'
											fontColor='primary'
											title='1.629,-'
											size='xs'
										/>
									</div>
								</div>
							</div>
							{replacedPlaceholder.additionalPriceDetails.map((item, index) => (
								<p
									key={index}
									className={styles.SummaryComponent__card__main__content__discount_info}
								>
									{item}
								</p>
							))}
						</div>
					</div>
					<div className={styles.SummaryComponent__card__footer}>
						{/* //TODO: Change this to a link later on! */}
						<p
							onClick={() => {
								displayModal(
									seeDetailsSection.title,
									seeDetailsSection.subtitle,
									seeDetailsSection.content
								);
							}}
							className={styles.SummaryComponent__card__footer__link}
						>
							{seeDetailsSection.linkText}
						</p>
					</div>
				</div>
			</Container>
		</section>
	);
};
